<script setup>
import FundeasySnackbar from './components/FundeasySnackbar.vue';
</script>

<template>
  <v-app style="height: 100%; width: 100%">
    <NuxtPage />
    <FundeasySnackbar />
  </v-app>
</template>

<style>
html {
  overflow-y: auto;
}

body {
  font-family: Inter, Roboto, Arial, sans-serif !important;
}

.text-transform-none {
  text-transform: none !important;
}
.v-input__details {
  padding-inline-start: 0px !important;
}
</style>
<style src="./AppVariables.css"></style>
